(ns app.domain.application.guards.licence
  (:require [app.domain.application.model :as app-model]
            [app.domain.licence.generic-model :as gl-model]
            [app.domain.licence.model :as licence-model]
            [app.domain.licence.renewal-model :as renewal-model]
            [app.domain.project.model :as project-model]
            [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [tilakone.core :as tk]))

(def related-licence-in-state
  {:name    :process.guard/related-licence-in-state
   :summary "Given a phase-entity, check that the licence related to this workspace
             is in a specific state."
   :type    :guard
   :handler (fn [{[_ & states]     ::tk/guard
                  {:keys [target]} :request}]
              (->> target
                   :entity/parent ; workspace
                   :licence/_workspaces
                   (every? (apply du/in-state-fn states))))})

(def related-contractor-registration-in-state
  {:name    :process.guard/related-contractor-registration-in-state
   :summary "Given a phase-entity, check that the CR related to this workspace
             is in a specific state."
   :type    :guard
   :handler (fn [{[_ & states]     ::tk/guard
                  {:keys [target]} :request}]
              (->> target
                   :entity/parent ; workspace
                   :contractor-registration/_workspaces
                   (every? (apply du/in-state-fn states))))})

(def no-pending-workspace?
  {:name    :process.guard/no-pending-licence-workspace?
   :type    :guard
   :summary (str "Check that there is not another workspace that is not yet finalized. Parameters are the "
                 "keywords for permit-type, category, work-type and work-target, with nil signifying "
                 "wildcard.")
   :handler (fn [{{:keys [target]}                                                               :request
                  [_ related-permit-type related-category related-work-type related-work-target] ::tk/guard}]
              (->> target
                   gl-model/get-workspaces
                   (filter (fn [{:workspace/keys [permit-type] :as ws}]
                             (and (or (nil? related-permit-type)
                                      (= permit-type related-permit-type))
                                  (or (nil? related-category)
                                      (= related-category
                                         (-> ws
                                             :workspace/category-group-config
                                             :group.config/target)))
                                  (or (and (nil? related-work-type) (nil? related-work-target))
                                      (let [app (workspace-model/workspace-application ws)]
                                        (and
                                          (or (nil? related-work-type)
                                              (= related-work-type
                                                 (-> app
                                                     app-model/single-work-type
                                                     :group.config/target))
                                              (and (= related-work-type :work-type/renewal)
                                                   (-> app
                                                       app-model/single-work-type
                                                       licence-model/renewal-group-config?)))
                                          (or (nil? related-work-target)
                                              (= related-work-target
                                                 (-> app
                                                     :application/work-target-group-config
                                                     :group.config/target))))))
                                  (not (project-model/workspace-inactive-or-in-archival? ws)))))
                   empty?))})

(def renewal-workspace?
  {:name    :process.guard/renewal-workspace?
   :type    :guard
   :summary "Check that the workspace renews a licence or contractor registration."
   :handler (fn [{{:keys [target]} :request}]
              (-> target :entity/parent renewal-model/renewal-target))})

(def guards
  [related-licence-in-state
   related-contractor-registration-in-state
   no-pending-workspace?
   renewal-workspace?])
